import { useState } from 'preact/hooks';
import { currentRoute, navigate } from '@/router';
import { cartCount, cartTotal } from '@/store/cart';
import { dashboard } from '@/store/dashboard';
import { performLogout } from '@/store/auth';
import { closeDrawer } from '@/store/ui';
import { numberFormat } from '@/utils/format';
import { APP_VERSION } from '@/version';
import { canShowInstallEntry, promptInstall } from '@/pwa/install';
import logo from '@/assets/img/logo.png';

export function Sidebar() {
  const [brandOpen, setBrandOpen] = useState(false);
  const partner = dashboard.value;
  const route = currentRoute.value;
  const count = cartCount.value;
  const total = cartTotal.value;

  function handleLogout(e) {
    e.preventDefault();
    if (confirm('Выйти из аккаунта?')) {
      performLogout();
      navigate('dashboard');
    }
  }

  function go(name) {
    return (e) => {
      e.preventDefault();
      navigate(name);
      closeDrawer(); // на мобиле — закрыть drawer после выбора раздела
    };
  }

  return (
    <aside class="sidebar">
      <div class="brand">
        <img src={logo} alt="Склад Колес" class="brand-img" />
        <div class="brand-logo">ООО «Кондор-Юг»</div>
        <div class="brand-caption">B2B Портал</div>
        <div class="brand-contacts">
          <div class="brand-contact">
            <div class="brand-contact-title">Офис:</div>
            <div>г. Новороссийск, ул. Луначарского, 28Д</div>
            <div>
              <a href="tel:+79886200010">+7&#8209;988&#8209;620&#8209;00&#8209;10</a>
              {', '}
              <a href="tel:+79898052523">+7&#8209;989&#8209;805&#8209;25&#8209;23</a>
            </div>
          </div>
          <div class="brand-contact">
            <div class="brand-contact-title">Магазин и склад «Шинный Двор»:</div>
            <div>г. Новороссийск, ул. Набережная Адмирала Серебрякова, 79Г</div>
            <div>
              <a href="tel:+79180500750">+7&#8209;918&#8209;050&#8209;07&#8209;50</a>
            </div>
          </div>
        </div>
      </div>
      <nav class="menu" aria-label="Главное меню">
        <a class={`menu-item ${route === 'dashboard' ? 'is-active' : ''}`} href="/" onClick={go('dashboard')}>
          Главная B2B
        </a>
        <a class={`menu-item ${route === 'orders' ? 'is-active' : ''}`} href="/orders" onClick={go('orders')}>
          Заказы
        </a>
        <a class={`menu-item ${route === 'search' ? 'is-active' : ''}`} href="/search" onClick={go('search')}>
          Поиск товаров
        </a>
        <a
          class={`menu-item menu-item-cart ${route === 'cart' ? 'is-active' : ''} ${count > 0 ? 'has-items' : ''}`}
          href="/cart"
          onClick={go('cart')}
        >
          <span class="menu-cart-icon" aria-hidden="true">
            <i class="fa-solid fa-cart-shopping" />
          </span>
          <span class="menu-cart-body">
            <span class="menu-cart-title">Корзина</span>
            <span class="menu-cart-info">
              {count > 0 ? (
                <>
                  <span class="menu-cart-count">{count} шт.</span>
                  <span class="menu-cart-sep">·</span>
                  <span class="menu-cart-sum">{numberFormat(total)} ₽</span>
                </>
              ) : (
                <span class="menu-cart-empty">пусто</span>
              )}
            </span>
          </span>
        </a>
        <a class={`menu-item ${route === 'promotions' ? 'is-active' : ''}`} href="/promotions" onClick={go('promotions')}>
          Акции
        </a>
        <a class={`menu-item ${route === 'useful' ? 'is-active' : ''}`} href="/useful" onClick={go('useful')}>
          Полезное
        </a>
        <div class="menu-group">
          <button
            type="button"
            class={`menu-item menu-item-toggle ${brandOpen ? 'active' : ''}`}
            onClick={() => setBrandOpen(!brandOpen)}
            aria-expanded={brandOpen}
          >
            Кондор-Юг<span class="caret" aria-hidden="true" />
          </button>
          <div class={`submenu ${brandOpen ? 'is-open' : ''}`}>
            <a class="submenu-link" href="#">Главная</a>
            <a class="submenu-link" href="#">О компании</a>
            <a class="submenu-link" href="#">Новости</a>
            <a class="submenu-link" href="#">Наша сеть</a>
            <a class="submenu-link" href="#">Официальные дилеры</a>
            <a class="submenu-link" href="#">Партнёрам</a>
          </div>
        </div>
      </nav>
      <div class="sidebar-footer">
        {(partner?.manager_name || partner?.manager_phone || partner?.manager_email) && (
          <div class="manager-phone">
            <div class="manager-caption" style={{ color: 'var(--color-accent)', fontWeight: 600, marginBottom: 4 }}>
              Ваш менеджер:
            </div>
            <div class="manager-info">
              {partner.manager_name && <div class="manager-name">{partner.manager_name}</div>}
              {partner.manager_phone && (
                <div>
                  <a href={`tel:${partner.manager_phone.replace(/[^\d+]/g, '')}`}>{partner.manager_phone}</a>
                </div>
              )}
              {partner.manager_email && (
                <div>
                  <a href={`mailto:${partner.manager_email}`}>{partner.manager_email}</a>
                </div>
              )}
            </div>
          </div>
        )}
        {canShowInstallEntry.value && (
          <button class="install-btn" type="button" onClick={() => promptInstall()}>
            <i class="fa-solid fa-download" aria-hidden="true" /> Установить приложение
          </button>
        )}
        <button class="logout-btn" type="button" onClick={handleLogout}>
          Выйти
        </button>
        <div class="app-version" title="Версия приложения">v{APP_VERSION}</div>
      </div>
    </aside>
  );
}
